import React, { useContext, useEffect, useState } from 'react';
import {
  Box,
  debounce,
  FormControl,
  FormHelperText,
  Input,
  InputLabel,
  Typography,
} from '@mui/material';
import {
  PersonOutlined as PersonOutlinedIcon,
} from '@mui/icons-material';
import IconCircle from 'components/IconCircle';
import IconRowCell from 'components/IconRowCell';
import IconRow from 'components/IconRow';
import PersonService from 'services/person';
import CreateProcessContext from 'shared/contexts/CreateProcessContext';
import { DICTIONARY } from 'shared/constants';
import { isValidEmail } from 'shared/utilities';

const panelStyle = {
  marginTop: '1rem',
  '& > .MuiPaper-root': {
    marginBottom: '1rem',
  },
};

interface Props {
  hideEmail?: boolean;
}

const NewEmployeeType: React.FC<Props> = ({ hideEmail }: Props) => {
  const {
    process,
    setEmailIsTaken,
    setProcess,
  } = useContext(CreateProcessContext);
  const [emailError, setEmailError] = useState('');

  const handleEmailChange = (event: any) => {
    setProcess((draft) => {
      draft.employeeData!.email = event.target.value;
    });
  };

  const handleFirstNameChange = (event: any) => {
    setProcess((draft) => {
      draft.employeeData!.firstname = event.target.value;
    });
  };

  const handleLastNameChange = (event: any) => {
    setProcess((draft) => {
      draft.employeeData!.lastname = event.target.value;
    });
  };

  useEffect(() => {
    let ignore = false;

    const checkEmail = debounce(async () => {
      setEmailIsTaken(true);
      const isTaken = await PersonService.isEmailTaken(
        process.employeeData?.email!,
      );

      if (!ignore) {
        setEmailIsTaken(isTaken);
        setEmailError(isTaken ? DICTIONARY.EmailTaken : '');
      }
    }, 200);

    if (process.employeeData?.email
      && isValidEmail(process.employeeData.email)) {
      checkEmail();
    }

    return () => { ignore = true; };
  }, [process.employeeData?.email]);

  return (
    <Box sx={panelStyle}>
      <IconRow>
        <IconRowCell type="icon">
          <IconCircle Icon={PersonOutlinedIcon} />
        </IconRowCell>
        <IconRowCell type="text">
          <Typography variant="h6">
            {DICTIONARY.AddNewIndividualsInformation}
          </Typography>
        </IconRowCell>
      </IconRow>

      <IconRow>
        <IconRowCell type="text">
          <FormControl style={{ width: '100%' }}>
            <InputLabel
              htmlFor="firstname-input"
              required
            >
              First Name
            </InputLabel>
            <Input
              id="firstname-input"
              value={process.employeeData!.firstname}
              onChange={handleFirstNameChange}
            />
          </FormControl>
        </IconRowCell>
      </IconRow>

      <IconRow>
        <IconRowCell type="text">
          <FormControl style={{ width: '100%' }}>
            <InputLabel htmlFor="lastname-input" required>Last Name</InputLabel>
            <Input
              id="lastname-input"
              value={process.employeeData!.lastname || ''}
              onChange={handleLastNameChange}
            />
          </FormControl>
        </IconRowCell>
      </IconRow>

      {!hideEmail && (
        <IconRow>
          <IconRowCell type="text">
            <FormControl
              style={{ width: '100%' }}
            >
              <InputLabel htmlFor="lastname-input" required>Email</InputLabel>
              <Input
                id="lastname-input"
                value={process.employeeData!.email || ''}
                onChange={handleEmailChange}
              />
              {emailError && (
                <FormHelperText error>{emailError}</FormHelperText>
              )}
            </FormControl>
          </IconRowCell>
        </IconRow>
      )}
    </Box>
  );
};

export default NewEmployeeType;
